<template>
    <div id="ans_1_1 proofs-block" class="ans_1" style="">
        <div id="masterBody_divUploadSOU1" class="inputSec">
            <table class="checkbox-block dxeBase_Material CustomCss dxeTAR" id="chk1">
                <tbody>
                    <tr>
                        <td class="dxichCellSys">
                            <div class="checkbox-wrapper">
                                <input v-model="check" class="proofs-block__checkbox" id="proof_product" type="radio" name="proof_radio" value="proof_product">
                            </div>
                        </td>
                        <td class="dxichTextCellSys proofs-block__label"><label for="proof_product">Upload a photo of your product showing this trademark.</label></td>
                    </tr>
                </tbody>
            </table>
            <div v-if="check == 'proof_product'" class="uploadCol mb-d border-top_none" id="divSOU1">
                <div>
                    <InputTextareaElement
                        v-model="proof_product.description"
                        label="Briefly describe what it is that you are attaching"
                    ></InputTextareaElement>
                </div>
                <DropZone
                    :src="proof_product.src"
                    @changeFile="changeFile($event, 'proof_product')"
                ></DropZone>
            </div>
        </div>


        <div id="masterBody_divUploadSOU2" class="inputSec">
            <table class="checkbox-block dxeBase_Material CustomCss dxeTAR" id="">
                <tbody>
                <tr>
                    <td class="dxichCellSys">
                        <div class="checkbox-wrapper">
                            <input v-model="check" class="proofs-block__checkbox" id="proof_product_package" type="radio" name="proof_radio" value="proof_product_package">
                        </div>
                    </td>
                    <td class="dxichTextCellSys proofs-block__label"><label for="proof_product_package">Upload a photo of your product package showing this trademark.</label></td>
                </tr>
                </tbody>
            </table>

            <div v-if="check == 'proof_product_package'" class="uploadCol mb-d" id="divSOU2">
                <DropZone
                    :src="proof_product_package.src"
                    @changeFile="changeFile($event, 'proof_product_package')"
                ></DropZone>
            </div>
        </div>

        <div id="masterBody_divUploadSOU3" class="inputSec">
            <table class="checkbox-block dxeBase_Material CustomCss dxeTAR" id="chk1">
                <tbody>
                <tr>
                    <td class="dxichCellSys">
                        <div class="checkbox-wrapper">
                            <input v-model="check" class="proofs-block__checkbox" id="proof_counter_display" type="radio" name="proof_radio" value="proof_counter_display">
                        </div>
                    </td>
                    <td class="dxichTextCellSys proofs-block__label"><label for="proof_counter_display">Upload a photo of a counter display of your product showing this trademark.</label></td>
                </tr>
                </tbody>
            </table>
            <div v-if="check == 'proof_counter_display'" class="uploadCol mb-d" id="divSOU3">
                <DropZone
                    :src="proof_counter_display.src"
                    @changeFile="changeFile($event, 'proof_counter_display')"
                ></DropZone>
            </div>
        </div>

        <div id="masterBody_divUploadSOU7" class="inputSec">
            <table class="checkbox-block dxeBase_Material CustomCss dxeTAR" id="chk1">
                <tbody>
                <tr>
                    <td class="dxichCellSys">
                        <div class="checkbox-wrapper">
                            <input v-model="check" class="proofs-block__checkbox" id="proof_website" type="radio" name="proof_radio" value="proof_website">
                        </div>
                    </td>
                    <td class="dxichTextCellSys proofs-block__label"><label for="proof_website">Upload a website screenshot</label></td>
                </tr>
                </tbody>
            </table>
            <div v-if="check == 'proof_website'" class="uploadCol mb-d border-top_none" id="divSOU7">
                <div>
                    <InputTextareaElement
                        v-model="proof_website.description"
                        label="Briefly describe what it is that you are attaching"
                    ></InputTextareaElement>
                </div>
                <DropZone
                    :src="proof_website.src"
                    @changeFile="changeFile($event, 'proof_website')"
                ></DropZone>
            </div>
        </div>

        <div id="masterBody_divUploadSOU8" class="inputSec">
            <table class="checkbox-block dxeBase_Material CustomCss dxeTAR" id="chk1">
                <tbody>
                <tr>
                    <td class="dxichCellSys">
                        <div class="checkbox-wrapper">
                            <input v-model="check" class="proofs-block__checkbox" id="proof_other" type="radio" name="proof_radio" value="proof_other">
                        </div>
                    </td>
                    <td class="dxichTextCellSys proofs-block__label"><label for="proof_other">Upload Other Proof</label></td>
                </tr>
                </tbody>
            </table>

            <div v-if="check == 'proof_other'" class="uploadCol mb-d border-top_none" id="divSOU8">
                <div>
                    <InputTextareaElement
                        v-model="proof_other.description"
                        label="Briefly describe what it is that you are attaching"
                    ></InputTextareaElement>
                </div>
                <DropZone
                    :src="proof_other.src"
                    @changeFile="changeFile($event, 'proof_other')"
                ></DropZone>
            </div>
        </div>
        <!-- end of upload doc -->
    </div>
</template>

<script>
import http from '@/api/http';
import DropZone from '@/components/DropZone.vue'
import InputTextareaElement from "@/ui/Input-Textarea";

export default {
    components: {
        DropZone,
        InputTextareaElement
    },
    props: {
        start_check: String,
        start_proof_product: Object,
        start_proof_product_package: Object,
        start_proof_counter_display: Object,
        start_proof_website: Object,
        start_proof_other: Object,
    },
    data() {
        return {
            check: this.start_check,
            proof_product: this.start_proof_product,
            proof_product_package: this.start_proof_product_package,
            proof_counter_display: this.start_proof_counter_display,
            proof_website: this.start_proof_website,
            proof_other: this.start_proof_other,
        }
    },
    watch: {
        start_check: {
            handler:function(newVal) {
                this.check = this.start_check
            },
            deep:true
        },
        start_proof_product: {
            handler:function(newVal) {
                this.proof_product = this.start_proof_product
            },
            deep:true
        },
        start_proof_product_package: {
            handler:function(newVal) {
                this.proof_product_package = this.start_proof_product_package
            },
            deep:true
        },
        start_proof_counter_display: {
            handler:function(newVal) {
                this.proof_counter_display = this.start_proof_counter_display
            },
            deep:true
        },
        start_proof_website: {
            handler:function(newVal) {
                this.proof_website = this.start_proof_website
            },
            deep:true
        },
        start_proof_other: {
            handler:function(newVal) {
                this.proof_other = this.start_proof_other
            },
            deep:true
        },
        check: {
            handler:function(newVal) {
                if (newVal != 'proof_product') {
                    this.proof_product = {
                        src: '',
                        file: '',
                        description: ''
                    }
                }
                if (newVal != 'proof_product_package') {
                    this.proof_product_package = {
                        src: '',
                        file: ''
                    }
                }

                if (newVal != 'proof_counter_display') {
                    this.proof_counter_display = {
                        src: '',
                        file: ''
                    }
                }

                if (newVal != 'proof_website') {
                    this.proof_website = {
                        src: '',
                        file: '',
                        description: ''
                    }
                }

                if (newVal != 'proof_other') {
                    this.proof_other = {
                        src: '',
                        file: '',
                        description: ''
                    }
                }

                this.$emit('update', this.params())
            },
            deep:true
        },
        proof_product: {
            handler:function(newVal) {
                this.$emit('update', this.params())
            },
            deep:true
        },
        proof_product_package: {
            handler:function(newVal) {
                this.$emit('update', this.params())
            },
            deep:true
        },
        proof_counter_display: {
            handler:function(newVal) {
                this.$emit('update', this.params())
            },
            deep:true
        },
        proof_website: {
            handler:function(newVal) {
                this.$emit('update', this.params())
            },
            deep:true
        },
        proof_other: {
            handler:function(newVal) {
                this.$emit('update', this.params())
            },
            deep:true
        },
    },
    mounted() {

    },
    methods: {
        changeFile(file, name){
            this[name].file = file
        },
        params(){
            return {
                proof_product: this.proof_product,
                proof_product_package: this.proof_product_package,
                proof_counter_display: this.proof_counter_display,
                proof_website: this.proof_website,
                proof_other: this.proof_other,
                check: this.check
            }
        },
    },
}
</script>

<style scoped>

input.form-control {
    max-width: 650px;
    margin: 10px 0px;
}
.checkbox-wrapper {
    height: 28px;
    margin-right: 5px;
    display: flex;
    align-items: center;
}
</style>
<style>
.proofs-block__label {
    font-weight: bold;
}
.proofs-block__checkbox {
    width: 24px;
    height: 24px;
}
.proofs-block__label {
    font-size: 18px;
    font-family: 'Inter';
}

@media screen and (max-width: 600px) {
    .proofs-block__checkbox {
        width: 15px;
        height: 15px;
    }
}
</style>
